module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/example-3-17beb3567e1ba50a67513f6c16199367.png";